import colors from '../../QTheme/colors';

export const Counter = {
  baseStyle: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  sizes: {
    sm: {
      height: 4,
      minHeight: 4,
      minWidth: 4,
      fontSize: 'xs',
      fontWeight: '600',
      px: 1,
      borderRadius: '8px',
    },
    md: {
      height: 5,
      minHeight: 5,
      minWidth: 5,
      fontSize: 'sm',
      fontWeight: '600',
      px: 1.5,
      borderRadius: '16px',
    },
  },
  variants: {
    blue: {
      color: 'blue.900',
      bg: 'blue.100',
    },
    gray: {
      color: 'gray.900',
      bg: 'gray.100',
    },
    red: {
      color: 'red.900',
      bg: 'red.100',
    },
    green: {
      color: 'green.900',
      bg: 'green.100',
    },
    yellow: {
      color: 'yellow.900',
      bg: 'yellow.100',
    },
    orange: {
      color: 'orange.900',
      bg: 'orange.100',
    },
    purple: {
      color: 'purple.900',
      bg: 'purple.100',
    },
    pink: {
      color: 'pink.900',
      bg: 'pink.100',
    },
    white: {
      color: 'blue.500',
      bg: 'white',
    },
    default: {
      color: 'white',
      bg: 'blue.500',
    },
    outline: {
      color: 'gray.700',
      bg: 'transparent',
      boxShadow: `inset 0 0 0px 1px ${colors.gray['200']}`,
    },
    invertedRed: {
      color: 'white',
      bg: 'red.500',
    },
  },
};
